import { UserAccountRoles } from '~/constants/userRoles'

export function useMenuPermissions() {
  const { ADMIN, CONTRIBUTOR_ALL_ORG_DATA, CONTRIBUTOR_ASSIGNED_DATA, VIEWER, USER_MANAGER } = UserAccountRoles

  const companiesPermission = usePagePermissions({
    canView: [ADMIN, VIEWER, USER_MANAGER],
  })

  const myAssignmentsPermission = usePagePermissions({
    canView: [ADMIN, CONTRIBUTOR_ALL_ORG_DATA, CONTRIBUTOR_ASSIGNED_DATA],
  })

  const esgDataEntryPermission = usePagePermissions({
    canView: [ADMIN, CONTRIBUTOR_ALL_ORG_DATA, CONTRIBUTOR_ASSIGNED_DATA],
  })

  const ghgDataApprovalPermission = usePagePermissions({
    canView: [ADMIN, CONTRIBUTOR_ALL_ORG_DATA, CONTRIBUTOR_ASSIGNED_DATA],
  })

  const ghgProgressTrackerPermission = usePagePermissions({
    canView: [ADMIN, VIEWER, USER_MANAGER],
  })

  const ghgDataEntryPermission = usePagePermissions({
    canView: [ADMIN, CONTRIBUTOR_ALL_ORG_DATA, CONTRIBUTOR_ASSIGNED_DATA],
  })

  const integrationPermission = usePagePermissions({
    canView: [ADMIN],
  })

  const ghgEmissionFactorConfigPermission = usePagePermissions({
    canView: [ADMIN, VIEWER, USER_MANAGER],
  })

  const dataAssignmentPermission = usePagePermissions({
    canView: [ADMIN, VIEWER, USER_MANAGER],
  })

  const esgMetricsConfigPermission = usePagePermissions({
    canView: [ADMIN, VIEWER, USER_MANAGER],
  })

  const assetsPermission = usePagePermissions({
    canView: [ADMIN, CONTRIBUTOR_ALL_ORG_DATA, CONTRIBUTOR_ASSIGNED_DATA, VIEWER, USER_MANAGER],
  })

  return {
    canViewCompanies: companiesPermission.canView,
    canViewMyAssignments: myAssignmentsPermission.canView,
    canViewEsgDataEntry: esgDataEntryPermission.canView,
    canViewGhgDataApproval: ghgDataApprovalPermission.canView,
    canViewGhgProgressTracker: ghgProgressTrackerPermission.canView,
    canViewGhgDataEntry: ghgDataEntryPermission.canView,
    canViewIntegration: integrationPermission.canView,
    canViewGhgEmissionFactorConfig: ghgEmissionFactorConfigPermission.canView,
    canViewDataAssignment: dataAssignmentPermission.canView,
    canViewEsgMetricsConfig: esgMetricsConfigPermission.canView,
    canViewAssets: assetsPermission.canView,
  }
}
